export enum EmailType {
  FreeFormat = 0,
  PropertyBulletinMatched = 1,
  PropertyDetails = 2,
  DevelopmentDetails = 3,
  PropertyBulletinAll = 4,
  PropertyDetailsFreeFormat = 5,
  Newsletter = 6,
  PropertyFeedbackRequest = 7,
}
